import { Moment } from "moment/moment";

export const DateFormat: string = 'DD-MM-YYYY';

export type NestDatePickerChangeView = {
  view?: NestDatePickerView;
  answer?: Moment;
}

export type NestDatePickerView = 'day' | 'month' | 'year' | 'decade'

export type NestDatePickerDay = {
  id: number;
  label: string;
  value?: string;
  year?: number;
  month?: number;
  day?: number;
  date?: Moment;

  current?: boolean;
  selected?: boolean;
  disabled?: boolean;
  hide?: boolean;

  isRange?: boolean;
  startRange?: boolean;
  endRange?: boolean;
}
